import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import MaterialTable from 'material-table';
import Select from 'react-select'

// reactstrap components
import { Button, Card, CardHeader, CardBody, FormGroup, Form, Input, Row, Col, Container, Modal, ModalHeader, ModalBody, ModalFooter, Alert, Label } from "reactstrap";

// style
import { table_translate, table_style } from "../../../constants/MaterialTable";

// services
import { showMessage, showQuestion } from "../../../services/message.js";
import { api_GET, api_POST, api_POST_File } from "../../../services/api_service.js";
import { EnviaProtocoloTransportadorEquipamento, EnviaRequerimentoTransportadorEquipamento } from "../../../services/protocolo_transportador_service.js";

//Context
import { useAuth } from "../../../context/auth";


export default function Equipamentos({ item, tipoCadastro, permiteManutencao, handleProximoStep, handleStepAnterior }) {
    const {session, setLoading, setupSistema} = useAuth();

    const { register, handleSubmit, errors, setError, setValue, clearErrors, reset } = useForm({ mode: "onBlur" });

    const [permiteEditar, set_permiteEditar] = React.useState(true);

    const [registro, set_registro] = React.useState(null);

    const [equipamentos, set_equipamentos] = React.useState([]);

    useEffect(() => {
        if (session != null && session.tipoAcesso == "AreaRestrita")
            set_permiteEditar(false);

        if (tipoCadastro == "Protocolo")
            loadItemProtocolo();
        else if (tipoCadastro == "Requerimento")
            loadItemRequerimento();
    }, []);
    const loadItemProtocolo = () => {
        set_registro(item);
        if (item != null && item.protocoloTransportador[0].protocoloTransportadorEquipamento != null) {
            set_equipamentos(item.protocoloTransportador[0].protocoloTransportadorEquipamento);
        }
    }


    const loadItemRequerimento = () => {
        set_registro(item);
        if (item != null && item.requerimentoTransportadorEquipamento != null) {
            set_equipamentos(item.requerimentoTransportadorEquipamento);
        }

        if ((tipoCadastro == "Requerimento") || (tipoCadastro == "Protocolo" && !permiteManutencao)) {
            let _action = actions;
            _action.push({
                icon: 'delete',
                tooltip: 'Remover Equipamento',
                onClick: (event, rowData) => handleRemove(rowData)
            });

            set_actions(_action);
        }
    }

    // Material-Table > Actions
    const [actions, set_actions] = useState([
        {
            icon: 'edit',
            tooltip: 'Editar Registro',
            onClick: (event, rowData) => handleEdit(rowData)
        }
    ]);

    // Status
    const [tipo, set_tipo] = React.useState("");
    const [options_tipo] = React.useState([
        { value: "Caçamba", label: "Caçamba" }
    ]);
    const handleTipo = (value) => {
        set_tipo(value);
        setValue("tipo", value, true);
        clearErrors("tipo");
    }

    // Status
    const [status, set_status] = React.useState("");
    const [options_status] = React.useState([
        { value: "Ativo", label: "Ativo" },
        { value: "Inativo", label: "Inativo" },
    ]);
    const handleStatus = (value) => {
        set_status(value);
        setValue("status", value, true);
        clearErrors("status");
    }

    // Modal
    const [modal, setModal] = React.useState(false);
    const toggleModalEquipamentos = () => {
        setModal(!modal);
    }
    const handleDownloadPlanilha = () => {
        window.open(setupSistema?.caminhoVirtual + "Equipamentos.xlsx", "_blank")
    }
    const [file, set_file] = React.useState(null);
    const [erros_importacao, set_erros_importacao] = React.useState([]);
    const handleChangeArquivo = (event) => {
        if (event.target.files.length) {
            set_file(event.target.files[0]);
        }
    }
    const handleImportarEquipamentos = () => {
        set_erros_importacao([]);
        if (tipoCadastro != "Requerimento") {
            set_erros_importacao([{ linha: 0, erro: "Só é possível importar o arquivo através de um requerimento do transportador!" }]);
            return;
        }
        if (file == null) {
            set_erros_importacao([{ linha: 0, erro: "Selecione o arquivo para importação!" }]);
            return;
        }
        var formData = new FormData();
        formData.append("file", file);

        setLoading(true);
        api_POST_File(`requerimentoTransportador/PostRequerimentoTransportadorEquipamentoFile/${item.requerimento_Id}`, formData).then(result => {
            let new_list = result.data;
            let _registro = registro;
            _registro.requerimentoTransportador[0].requerimentoTransportadorEquipamento = new_list;
            set_equipamentos(new_list);
            set_registro(_registro);
            setModal(false);
            showMessage("Aviso", "Importação concluída com sucesso!", 'success', null);
        }).catch(err => { set_erros_importacao(err.message); })
            .finally(() => setLoading(false));
    }

    const [rowEdit, set_rowEdit] = React.useState(null);
    const handleEdit = (rowData) => {
        set_rowEdit(rowData);
        setValue("numeroEquipamento", rowData.numeroEquipamento);
        setValue("tipo", rowData.tipo, true);
        set_tipo(rowData.tipo);
        setValue("dimensao", rowData.dimensao);
        setValue("capacidadeVolume", rowData.capacidadeVolume);
        set_status(rowData.status);
        setValue("status", rowData.status, true);
    }

    const handleRemove = (rowData) => {
        if (!permiteManutencao && tipoCadastro == "Protocolo") {
            showMessage("Aviso", "Não permitida a manutenção do cadastro.", 'error', null);
            return;
        }

        showQuestion('Atenção', 'Deseja remover este equipamento?', 'question', function (result) {
            if (result) {
                setLoading(true);
                let _usuarioId = session != null && session.tipoAcesso == "AreaRestrita" ? session.usuario_Id : 0;

                if (tipoCadastro == "Protocolo") {
                    api_POST('protocoloTransportador/PostRemoveEquipamentoProtocolo/' + _usuarioId + "/" + rowData.protocoloTransportadorEquipamento_Id)
                        .then(result => {
                            showMessage("Aviso", "Equipamento removido com sucesso!", 'success', function () {
                                handleReturnRemove(rowData.protocoloTransportador_Id);
                            });
                        })
                        .catch(err => showMessage("Aviso", err.message, 'error', null))
                        .finally(() => setLoading(false));
                }
                else {
                    api_POST('requerimentoTransportador/PostRemoverEquipamentoRequerimento/' + rowData.requerimentoTransportadorEquipamento_Id)
                        .then(result => {
                            showMessage("Aviso", "Equipamento removido com sucesso!", 'success', function () {
                                handleReturnRemove(rowData.requerimento_Id);
                            });
                        })
                        .catch(err => showMessage("Aviso", err.message, 'error', null))
                        .finally(() => setLoading(false));
                }
            }
        })
    }
    const handleReturnRemove = (reloadId) => {
        setLoading(true);

        if (tipoCadastro == "Protocolo") {
            api_GET('protocoloTransportador/GetEquipamentosProtocolo/' + reloadId)
                .then(result => set_equipamentos(result.data))
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
        else {
            api_GET('requerimentoTransportador/GetEquipamentosRequerimento/' + reloadId)
                .then(result => set_equipamentos(result.data))
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
    }

    const onSubmit = (data) => {
        if (rowEdit == null && equipamentos.filter(f => f.numeroEquipamento == data.numeroEquipamento).length > 0) {
            showMessage("Aviso", "Já existe um equipamento com esta numeração!", 'error', null);
            return;
        }

        setLoading(true);
        if (permiteManutencao && tipoCadastro == "Protocolo") {
            let json = carregaJsonProtocolo(data);
            EnviaProtocoloTransportadorEquipamento(json, confirmaAddEquipamento)
        }
        else if (tipoCadastro == "Requerimento") {
            let json = carregaJsonRequerimento(data);
            EnviaRequerimentoTransportadorEquipamento(json, confirmaAddEquipamento)
        }
    }
    const carregaJsonProtocolo = (data) => {
        let json_submit = {
            protocoloTransportadorEquipamento_Id: rowEdit == null ? 0 : rowEdit.protocoloTransportadorEquipamento_Id,
            protocoloTransportador_Id: item.protocoloTransportador[0].protocoloTransportador_Id,
            numeroEquipamento: data.numeroEquipamento,
            tipo: tipo,
            dimensao: data.dimensao,
            capacidadeVolume: data.capacidadeVolume,
            status: status == "" ? "Ativo" : "",
            usuarioUltimaAlteracao_Id: session != null && session.tipoAcesso == "AreaRestrita" ? session.usuario_Id : null
        }
        return json_submit;
    }
    const carregaJsonRequerimento = (data) => {
        let json_submit = {
            requerimentoTransportadorEquipamento_Id: rowEdit == null ? 0 : rowEdit.requerimentoTransportadorEquipamento_Id,
            requerimento_Id: item.requerimento_Id,
            numeroEquipamento: data.numeroEquipamento,
            tipo: tipo,
            dimensao: data.dimensao,
            capacidadeVolume: data.capacidadeVolume,
            status: "Ativo",
            usuarioUltimaAlteracao_Id: session != null && session.tipoAcesso == "AreaRestrita" ? session.usuario_Id : null
        }
        return json_submit;
    }
    const confirmaAddEquipamento = (result) => {
        setLoading(false);
        let equipamento = result.data;

        let new_list = [];
        let _registro = registro;
        if (tipoCadastro == "Protocolo") {
            equipamentos.map(m => {
                if (m.protocoloTransportadorEquipamento_Id != equipamento.protocoloTransportadorEquipamento_Id)
                    new_list.push(m);
            });
            _registro.protocoloTransportador[0].protocoloTransportadorEquipamento = new_list;
        }
        else if (tipoCadastro == "Requerimento") {
            equipamentos.map(m => {
                if (m.requerimentoTransportadorEquipamento_Id != equipamento.requerimentoTransportadorEquipamento_Id)
                    new_list.push(m);
            });
            _registro.requerimentoTransportadorEquipamento = new_list;
        }

        new_list.push(equipamento);
        set_equipamentos(new_list);
        set_registro(_registro);

        setValue("numeroEquipamento", "");
        setValue("tipo", "", false);
        set_tipo("");
        setValue("dimensao", "");
        setValue("capacidadeVolume", "");
        set_status("");
        setValue("status", "", false);

        set_rowEdit(null);

        showMessage("Aviso", "Operação executada com sucesso", 'success', null);
    }

    const handleAvancar = () => {
        if ((session == null || (session && session.tipoAcesso == "Protocolo")) && equipamentos.length == 0 && tipoCadastro == "Requerimento" && registro.requerimentoTransportadorVeiculo.filter(v => v.tipo == "Poliguindaste" || v.tipo == "Roll-on Roll-off").length > 0) {
            showMessage("Aviso", "Você não pode avançar sem informar os equipamentos", 'error', null);
            return;
        }
        handleProximoStep(registro);
    }

    return (
        <>
            <div>
                <Card className="card-stats">
                    <CardHeader>
                        <Row><Col md="12" className="text-right"><label className="text-danger">* Campos Obrigatórios</label></Col></Row>
                    </CardHeader>
                    <CardBody>
                        <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                            <h2 className="titulo-solicitacao">Equipamentos</h2>
                            <div className="formPrincipal">
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <Row>
                                        <Col md="3" lg="3">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Número do Equipamento</label></b>
                                                <Input type="text" name="numeroEquipamento" innerRef={register({ required: true })} />
                                                {errors.numeroEquipamento && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="3" lg="3">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Tipo</label></b>
                                                <Select
                                                    options={options_tipo}
                                                    name="tipo"
                                                    onChange={(e) => { handleTipo(e.value) }}
                                                    getOptionLabel={({ label }) => label}
                                                    getOptionValue={({ value }) => value}
                                                    value={tipo != "" && options_tipo.find(obj => obj.value === tipo)}
                                                    placeholder="Selecione"
                                                    ref={e => register(
                                                        { name: "tipo" },
                                                        { required: true })
                                                    }
                                                />
                                                {errors.tipo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Dimensão (m²)</label></b>
                                                <Input type="text" name="dimensao" innerRef={register({ required: true })} />
                                                {errors.dimensao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Volume (m³)</label></b>
                                                <Input type="number" step="0.1" name="capacidadeVolume" innerRef={register({ required: true })} />
                                                {errors.capacidadeVolume && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md={12}>
                                            <Label>
                                                <b className="text-danger">Observação: </b> Informe a lista completa de equipamentos. Os equipamentos existentes em seu cadastro e não informados na lista serão excluídos.
                                            </Label>
                                        </Col>
                                        {session != null && session.tipoAcesso == "AreaRestrita" &&
                                            <Col md="2" lg="2">
                                                <FormGroup>
                                                    <b><label><span className="text-danger">*</span> Status</label></b>
                                                    <Select
                                                        options={options_status}
                                                        name="status"
                                                        onChange={(e) => { handleStatus(e.value) }}
                                                        getOptionLabel={({ label }) => label}
                                                        getOptionValue={({ value }) => value}
                                                        value={status != "" && options_status.find(obj => obj.value === status)}
                                                        placeholder="Selecione"
                                                        ref={e => register(
                                                            { name: "status" },
                                                            { required: true })
                                                        }
                                                    />
                                                    {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                        }
                                        {tipoCadastro == "Requerimento" &&
                                            <Col md="12" lg="12" style={{}}>
                                                <Button disabled={session != null && session.tipoAcesso == "AreaRestrita" && !permiteEditar} color="info" className="btn-link" type="button" onClick={toggleModalEquipamentos}>  <i className="fas fa-file-import"></i> Clique aqui para importar uma lista de equipamentos</Button>
                                            </Col>
                                        }
                                        {permiteEditar &&
                                            <Col md="12" lg="12" className="text-center">
                                                <FormGroup>
                                                    <Button color="success" className="btn-mobile" type="submit">  <i className="fas fa-save"></i> Salvar Equipamento</Button>
                                                </FormGroup>
                                            </Col>
                                        }
                                    </Row>
                                </Form>
                            </div>
                            <Row>
                                <Col md="12">
                                    <MaterialTable style={{ minHeight: "auto" }}
                                        title=""
                                        columns={[
                                            { title: 'Número Equipamento', field: 'numeroEquipamento' },
                                            { title: 'Tipo', field: 'tipo' },
                                            { title: 'Dimensão (m²)', field: 'dimensao' },
                                            { title: 'Volume (m³)', field: 'capacidadeVolume' },
                                            { title: 'Status', field: 'status' },

                                        ]}
                                        data={equipamentos}
                                        isLoading={false}
                                        options={{
                                            ...table_style,
                                            filtering: false,
                                            exportButton: true
                                        }}
                                        actions={actions}
                                        localization={table_translate}
                                    />
                                </Col>
                                <Col lg="6" className="text-left">
                                    <Button color="secundary" onClick={() => handleStepAnterior(registro)} className="btn-mobile" type="submit"><i className="fas fa-chevron-left"></i> Voltar</Button>
                                </Col>
                                <Col lg="6" className="text-right">
                                    <Button color="success" onClick={handleAvancar} className="btn-mobile" type="button">Próxima Etapa  <i className="fas fa-chevron-right"></i></Button>
                                </Col>
                            </Row>
                        </Container>
                    </CardBody>
                </Card>

                <Modal centered isOpen={modal} toggle={toggleModalEquipamentos} zIndex="9999999">
                    <ModalHeader toggle={toggleModalEquipamentos} close={<button className="close" onClick={toggleModalEquipamentos}>&times;</button>} className="md-hd"><i class="fas fa-file-excel"></i>  Importar Equipamentos</ModalHeader>
                    <ModalBody className="md-bd">
                        <h6>Siga as instruções abaixo para preencher a planilha:</h6>
                        <Row>
                            <Col lg="12">
                                <p>1. O campo "Tipo" deve ser preenchido com o texto "Caçamba";</p>
                                <p>2. O campo "Numero" corresponde ao Número de Identificação do equipamento;</p>
                                <p>3. O campo "Dimensao" deve ser preenchido com a largura x altura x comprimento do equipamento;</p>
                                <p>4. O campo "Volume" deve possuir apenas números e ser preenchido com a capacidade em m³.</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="12" className="text-center">
                                <Button color="info" className="btn-link" type="button" onClick={handleDownloadPlanilha}> <i className="fas fa-file-download"></i> Download da Planilha Modelo</Button>
                            </Col>
                            <Col lg="12">
                                <FormGroup>
                                    <b><label>Escolher Arquivo (.xlsx)</label></b>
                                    <Input type="file" name="arquivo" accept=".xlsx" onChange={handleChangeArquivo} />
                                </FormGroup>
                            </Col>
                            {erros_importacao != null && erros_importacao.length > 0 && erros_importacao.map((m, key) => (
                                <Col lg="12" key={key}>
                                    <Alert color="danger">{m.linha > 0 ? ("Linha " + m.linha + " - ") : ""} {m.erro}</Alert>
                                </Col>
                            ))
                            }
                        </Row>
                    </ModalBody>
                    <ModalFooter className="md-ft">
                        <Button color="success" onClick={handleImportarEquipamentos}><i className="fas fa-file-upload"></i>  Confirmar</Button>
                        <Button color="secondary" onClick={toggleModalEquipamentos}>Cancelar</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </>
    );
}           